import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Subject} from 'rxjs';
import {DataTableDirective} from 'angular-datatables';
import {ProcedureList} from '../_models/procedureList.model';
import {ProceduresService} from '../_services/procedures.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {CurrentUserDataService} from '../../../shared/_services/current-user-data.service';

@Component({
    selector: 'app-list-procedures',
    templateUrl: './list-procedures.component.html',
    styleUrls: ['./list-procedures.component.scss']
})
export class ListProceduresComponent implements OnInit, AfterViewInit, OnDestroy {

    // Data Tables
    @ViewChild(DataTableDirective) datatableElement: DataTableDirective;
    dtOptions: any = {};
    procedures: Array<ProcedureList>;
    dtTrigger: Subject<any> = new Subject<any>();


    // Feedback Messages
    formResponse: boolean;
    formSent: boolean;
    successMsg: string;
    errorMsg: string;

    // User
    userRole;

    // Filter
    hideFilters = true;

    // Subscriptions
    subscriptions = [];


    constructor(
        private procedureService: ProceduresService,
        private modalService: NgbModal,
        public currentUserData: CurrentUserDataService) {
    }


    ngOnInit(): void {
        this.dtOptions = {
            pagingType: 'full_numbers',
            pageLength: 10,
            columnDefs: [{
                targets: 5,
                orderable: false
            }, {
                targets: 3,
                render: (data, type) => {
                    const dateDisplay = data.split('-').reverse().join('/');
                    return type === 'display' || type === 'filter' ? dateDisplay : data;
                }
            }, {
                width: '1%',
                targets: [0, -1]
            }, {
                width: '20%',
                targets: [1, 2]
            }, {
                className: 'dtr-control',
                orderable: false,
                targets: -1
            }, {
                targets: 1,
                responsivePriority: 1
            }, {
                targets: 4,
                responsivePriority: 2
            }],
            initComplete: (settings, json) => {
                $('#myTable').show();
                $('#mySpinner').hide();
            },
            autoWidth: false,
            responsive: {
                details: {
                    type: 'column',
                    target: -1,
                    renderer: $.fn.dataTable['Responsive'].renderer.listHiddenNodes()
                }
            },
            dom: '<<t>pl>',
            order: [[0, 'desc']]
        };
        this.getUser();
    }

    getMainIdProcedures() {
        const getMainIdProcedures = this.procedureService.getMainIdProcedures().subscribe((data: Array<ProcedureList>) => {
            this.procedures = data;
            this.dtTrigger.next();
        });

        // Subscription
        this.subscriptions.push(getMainIdProcedures);
    }

    getAllProcedures() {
        const getAllProcedures = this.procedureService.getAllProcedures().subscribe((data: Array<ProcedureList>) => {
            this.procedures = data;
            this.dtTrigger.next();
        });

        // Subscription
        this.subscriptions.push(getAllProcedures);
    }


    // Get User Data
    getUser() {
        const getCurrentUser = this.currentUserData.getCurrentUserData().subscribe(data => {
            this.userRole = data.roles;

            if (this.userRole.includes('ROLE_super_admin')) {
                this.getAllProcedures();
            } else {
                this.getMainIdProcedures();
            }
        });

        // Add request to unsubscribe list
        this.subscriptions.push(getCurrentUser);
    }

    changeStatusModal(statusChange) {
        this.modalService.open(statusChange, {centered: true});
    }

    changeStatus(id, status) {
        $('#myTable').hide();
        $('#mySpinner').show();

        const changeProcedureStatus = this.procedureService.changeProcedureStatus(id, status).subscribe(resp => {
            if (this.userRole.includes('ROLE_super_admin')) {
                this.procedureService.getAllProcedures().subscribe((data: any) => {
                    this.procedures = data;
                    this.rerender();
                });
            } else {
                this.procedureService.getMainIdProcedures().subscribe((data: any) => {
                    this.procedures = data;
                    this.rerender();
                });
            }
            this.modalService.dismissAll();
            // Feedback Message
            this.feedbackMsg('success', 'Status successfully changed!');
        }, error => {
            
            // Feedback Message
            this.feedbackMsg('error', 'Error changing status');
        });

        // Subscription
        this.subscriptions.push(changeProcedureStatus);
    }

    rerender() {
        this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
            // Destroy the table first
            dtInstance.destroy();
            // Call the dtTrigger to rerender again
            this.dtTrigger.next();
        });
    }


    ngAfterViewInit() {
        const dtTrigger = this.dtTrigger.subscribe(() => {
            this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {

                $('#procedureStatusSelect').on('change', function() {
                    dtInstance
                        .columns(4)
                        .search('\\b' + this['value'] + '\\b', true, false)
                        .draw();
                });

                $('#tableSearchBox').on('keyup search input paste cut', function() {
                    dtInstance
                        .search(this['value'])
                        .draw();
                });
            });
        });

        // Subscription
        this.subscriptions.push(dtTrigger);
    }

    toggleFilters() {
        $('#filtersRow').slideToggle();
        this.hideFilters = !this.hideFilters;
    }


    // FeedBack Msg
    feedbackMsg(type, message) {
        if (type === 'success') {
            this.formSent = true;
            this.formResponse = true;
            this.successMsg = message;

            setTimeout(() => {
                this.formSent = false;
            }, 4000);

        } else if (type === 'error') {
            this.formSent = true;
            this.formResponse = false;
            this.errorMsg = message;

            setTimeout(() => {
                this.formSent = false;
            }, 4000);
        }
    }


    ngOnDestroy() {
        // Do not forget to unsubscribe the event
        this.dtTrigger.unsubscribe();
        this.subscriptions.forEach(sb => sb.unsubscribe());
    }

}
